<template>
  <!-- 新增/编辑会员信息弹窗 -->
  <el-dialog
    v-if="dialogVisible"
    class="dialogEdit"
    :title="formData.memberId ? '编辑会员' : '新增会员'"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="320px"
    @close="closeHandle"
  >
    <el-form ref="memberFormRef" label-width="80px" :rules="rules" :model="memberFormInfo" inline>
      <el-form-item label="姓 名" prop="memberName">
        <el-input v-model="memberFormInfo.memberName" clearable placeholder="请输入会员姓名" />
      </el-form-item>
      <el-form-item label="性 别" prop="sex">
        <el-radio-group v-model="memberFormInfo.sex">
          <el-radio :label="'0'">男</el-radio>
          <el-radio :label="'1'">女</el-radio>
          <el-radio :label="'2'">未知</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="生 日" prop="birthday">
        <el-date-picker
          v-model="memberFormInfo.birthday"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择患者生日"
          @blur="birthdayBlurHandle(memberFormInfo)"
          :picker-options="pickerOptions"
        />
      </el-form-item>
      <el-form-item label="年 龄" prop="year" class="patientAge">
        <el-form-item prop="year">
          <el-input v-model.number="memberFormInfo.year" @blur="computeBirthday">
            <template slot="append">岁</template>
          </el-input>
        </el-form-item>
        <el-form-item prop="month">
          <el-input v-model.number="memberFormInfo.month" @blur="computeBirthday">
            <template slot="append">月</template>
          </el-input>
        </el-form-item>
      </el-form-item>
      <el-form-item label="电 话" prop="phone">
        <el-input v-model="memberFormInfo.phone" :disabled="formData.memberId" clearable placeholder="请输入联系电话" />
      </el-form-item>
      <el-form-item label="来 源" prop="source">
        <el-select v-model="memberFormInfo.source" style="width: 220px;" clearable placeholder="请选择会员来源">
          <el-option v-for="item in sourceOptions" :key="item" :label="item" :value="item" />
        </el-select>
      </el-form-item>
    </el-form>
    <!-- 操作按钮 -->
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" v-if="!formData.memberId" :loading="saveBtnLoading" @click="addMemberHandle(memberFormInfo)">保存新增</el-button>
      <el-button type="primary" v-if="!!formData.memberId" :loading="saveBtnLoading" @click="editMemberHandle(memberFormInfo)">保存修改</el-button>
      <el-button :disabled="saveBtnLoading" @click="closeHandle">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { memberEdit, memberAdd } from "@/api/member" // 会员请求
import { validateName, validatePhone } from "@/utils/regexp" // 自定义验证
export default {
  data() {
    const validateYear = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error("请输入年龄"))
      }
      if (value < 0) {
        return callback(new Error("年龄不能小于0"))
      }
      return callback()
    }

    const validateMonth = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error("请输入月份"))
      }
      if (value < 0 || value > 11) {
        return callback(new Error("请输入0-11的数字"))
      }
      return callback()
    }
    
    return {
      memberFormInfo: {},
      rules: { // 表单验证规则
        memberName: [{ required: true, validator: validateName, trigger: 'blur' }],
        phone: [{ required: true, validator: validatePhone, trigger: 'blur' }],
        birthday: [{ required: true, message: '请选择生日', trigger: 'change' }],
        sex: [{ required: true, message: '请选择患者性别', trigger: 'change' }],
        source: [{ required: true, message: "请选择患者来源", trigger: 'change' }],
        year: [{ required: true, validator: validateYear, trigger: 'blur' }],
        month: [{ required: true, validator: validateMonth, trigger: 'blur' }],
      },
      sourceOptions: this.$sourceOptions, // 患者来源选项
      pickerOptions: { // 日期不可选范围
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      saveBtnLoading: false
    }
  },
  methods: {
    birthdayBlurHandle(memberFormInfo) {
      this.$computeAge(memberFormInfo.birthday, memberFormInfo)
      this.$refs.memberFormRef.validateField('year')
      this.$refs.memberFormRef.validateField('month')
    },
    // 计算生日
    computeBirthday() {
      this.memberFormInfo.birthday = this.$computeBirthday(this.memberFormInfo.year, this.memberFormInfo.month)
    },

    // 关闭弹窗
    closeHandle() {
      this.$refs['memberFormRef'].resetFields()
      this.dialogVisible = false
    },

    // 添加会员
    addMemberHandle() {
      this.$refs['memberFormRef'].validate(async (valid) => {
        if (valid) {
          this.saveBtnLoading = true
          const res = await memberAdd(this.memberFormInfo)
          this.saveBtnLoading = false
          if (res.code == 200) {
            this.$message.success("新增会员成功！")
            this.$emit('updateMemberInfoHandle', {
              ...this.memberFormInfo,
              memberId: res.data || ''
            })
            this.dialogVisible = false
          }
        }
      })
    },
    
    // 修改会员
    editMemberHandle() {
      this.$refs['memberFormRef'].validate(async (valid) => {
        if (valid) {
          this.saveBtnLoading = true
          const res = await memberEdit(this.memberFormInfo)
          this.saveBtnLoading = false
          if (res.code == 200) {
            this.$message.success("修改会员成功！")
            this.$emit('updateMemberInfoHandle', this.memberFormInfo)
            this.dialogVisible = false
          }
        }
      })
    },
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => {
        return {
          memberName: '',
          sex: "0",
          year: '',
          month: '',
          day: '',
          birthday: '',
          phone: '',
          source: ''
        }
      }
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('input', newVal)
      }
    }
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.memberFormInfo = JSON.parse(JSON.stringify(this.formData))
      }
    }
  }
}

</script>

<style scoped lang='less'>
.search .el-form > div {
  margin-bottom: 20px!important;
}

/deep/ .el-form-item__content {
  line-height: 40px!important;
}


.patientAge /deep/ .el-form-item__content {
  margin-top: 2px;
}
.search .el-input, 
/deep/ .el-input.el-input--suffix,
.search .el-select {
  max-width: 250px!important;
}
</style>